import { IRootState } from '../../../store'
import { IPcsInformationState } from '../store/pcsInformation.types'

export const getPcsInformationSelector = (state: IRootState): IPcsInformationState => state.pcsInformation
